angular.module('bribac.translations.en', [])

  .constant('EN_TRANSLATIONS', {

    today: "Today",
    scheduled_test: "Scheduled test",
    optional_test: "Optional test",

    bacUnits: {
      short: {
        BRAC: 'brAC',
        BAC_PER_MILLE: '‰',
        BAC_PERCENT: '%'
      },
      long: {
        BRAC: 'brAC',
        BAC_PER_MILLE: '‰ (per mille)',
        BAC_PERCENT: '% (percent)'
      }
    },

    boolean: {
      yes: 'Yes',
      no: 'No',
    },

    components: {
      agentDetails: {
        role: 'Role',
        fullAddress: 'Address',
        fullAddressValue: '{{address}}, {{postalCode}}, {{city}}',
        phone: 'Phone number',
        email: 'Email address',
        status: 'Status',
      },

      agentEditor: {
        firstName: 'First name',
        lastName: 'Last name',
        phone: 'Phone number (including country code)',
        email: 'Email address',
        streetAddress: 'Street address',
        postalCode: 'Postal code',
        city: 'City',
        organization: 'Organization',
        roleHeading: 'Role',
        notAllowedToChangeRole: 'You are not allowed to change this agents role.',
        systemLanguageHeading: 'System language',
        groupsHeading: 'Groups',
        mustChooseOrganizationBeforeGroups: 'You must choose an organization before you can choose groups.',
        thisGroupDoesntHaveAnySubGroups: 'This group doesn\'t have any sub groups.',
        agentSettingsHeading: 'Agent settings',
        notifyAgentUsing: 'Notify agent using…',
        calibrationNotification: "Receive calibration notifications",
        scheduleEndNotification: "Receive end of schedule notifications",
        deleteAgent: "DELETE",
      },

      collapsingBox: {
        expand: 'Expand',
        collapse: 'Collapse',
      },

      ibacDetails: {
        macAddress: 'MAC address',
        lastUsed: 'Last used',
        lastCalibrated: 'Last calibrated',
        cycles: 'Cycles',
        cyclesLeftUntilMaintenance: 'Cycles left until maintenance',
        daysLeftUntilMaintenance: 'Days left until maintenance',
        showDetails: 'Show details',
        lastLocation: 'Last location',
        locationNotAvailable: 'Last location not available',
        status: 'Status',
        editIbac: 'Edit iBac',
        batteryCharge: 'Battery charge',
        batteryEstimation: 'Remaining operating hours',
        assignedToSubject: 'Assigned to subject'
      },

      ibacEditor: {
        macAddress: 'MAC address',
        organization: 'Organization',
        ibac: 'iBac'
      },

      inputFile: {
        selectImage: 'Select Image',
        imageToUpload: 'Image to Upload',
        selectCsv: 'CSV file to upload'
      },

      csvUpload: {
        selectCsv: 'Select CSV',
        csvToUpload: 'CSV to Upload'
      },

      mainGroupEditor: {
        name: 'Name',
      },

      mainGroupOverview: {
        thereAreNoSubGroupsInName: 'There are no sub groups in {{name}}.',
        noGroups: 'There are no groups.'
      },

      mainMenu: {
        home: 'Home',
        add: 'Add',
        templates: 'Templates',
        groups: 'Groups',
        search: 'Search',
        myProfile: 'My profile',
        reports: 'Reports',
        ibac: 'iBac',
        organizations: 'Organizations',
        notes: 'Notes',
        logOut: 'Log out',
        alerts: 'Alerts',
        documentation: 'Documentation'
      },

      mainGroupSubGroupPicker: {
        noGroupsInOrganization: "There are no groups in the organization."
      },

      reportModal: {
        reportSubjectFullName: 'Report of {{fullName}}',
        cancel: 'Cancel',
        download: 'Download',
        processing: 'Processing...',
        startDate: 'Start date',
        endDate: 'End date'
      },

      messageEditorModal: {
        sendSmsToFullName: 'Send SMS to {{fullName}}',
        theSmsWasSentToFullName: 'The SMS was sent to {{fullName}}',
        characters: 'characters',
        cancel: 'Cancel',
        close: 'Close',
        sendTheSms: 'Send the SMS',
      },

      samplesChartModal: {
        samplesForFullName: 'Alcohol samples for {{fullName}}',
        rangeButtons: {
          lastWeek: 'Last week',
          lastMonth: 'Last month',
          lastSixMonths: 'Last six months',
          lastYear: 'Last year',
        },
        typeButtons: {
          mood: 'Mood',
          failedFRS: 'Failed FRS',
          failedAlcohol: 'Failed Alcohol',
          missedSchedule: 'Missed Schedule',
        },
        back: 'Back'
      },

      datePickerPopup: {
        reset: 'Clear',
        today: 'Today',
        done: 'Done'
      },

      noteEditor: {
        text: 'Text',
      },

      optionalSampleOverview: {
        passedOnDate: 'Passed on {{dateCreated | date:"short"}}',
        failedOnDate: 'Failed on {{dateCreated | date:"short"}}',
      },

      organizationDetails: {
        organizationalNumber: 'Organizational number',
        licenseType: 'License type',
        bacUnit: 'BAC unit',
        settings: 'Settings',
        messageSupport: 'Can send messages to subjects',
        noteSupport: 'Can attach notes to subjects',
        randomTests: 'Can create/use schedules with random tests',
        roleManagement: 'Can define different administrative roles',
        faceRecognition: 'Can use face recognition',
        createSubjectSummaryReport: 'Can generate summary report of Subject',
        status: 'Status',
      },

      organizationEditor: {
        name: 'Name',
        organizationalNumber: 'Organizational number',
        bacUnitHeading: 'BAC unit',
        licenseTypeHeading: 'License type',
        settingsHeading: 'Settings',
        cantConfigSettingsForNewOrg: 'You can\'t configured the settings while you\'re adding a new organization.',
        messageSupport: 'Can send messages to subjects',
        noteSupport: 'Can attach notes to subjects',
        randomTests: 'Can create/use schedules with random tests',
        roleManagement: 'Can define different administrative roles',
        faceRecognition: 'Can use face recognition',
        createSubjectSummaryReport: 'Can generate summary report of subject',
        notifyWhen: 'Notify when iBac has',
        leftUntilCalibration: 'Left until calibration',
        notifyWhenCalibrationDaysLeft: 'Notify when iBac has {{value}} days left until calibration',
        notifyWhenCalibrationCyclesLeft: 'Notify when iBac has {{value}} cycles left until calibration',
        cycles: 'cycles',
        days: 'days',
        hasToBeNumber: 'Has to be number',
        higherThanZero: 'Has to be bigger than zero',
        notifyEndScheduleDaysLeft: 'Notify when schedule ends in',
        notifyWhenEndOfScheduleDaysLeft: 'Notify when schedule has {{value}} day(s) left to end'
      },

      ruleSetDetails: {
        alcoholLimit: 'Alcohol limit',
        testExpiresAfter: 'Test expires after',
        testExpiresAfterSecondsValue: '{{testExpiresAfterSeconds / 60}} min',
        showResultsToSubject: 'Show results to subject',
        showCalibrationAlert: 'Show calibration alerts',
        notifyMonitorsWhen: 'Notify monitors when…',
        notifySubjectsUsing: 'Notify subjects using…',
        gpsRequired: 'GPS location is required'
      },

      ruleSetEditor: {
        name: 'Name',
        testExpiresAfterSecondsUnit: 'seconds',
        saveTemplateCopy: 'Save a copy as a template',
        templatesReuse: 'Templates can be reused with other subjects.',
        alcoholLimit: 'Alcohol limit',
        cancel: 'Cancel',
        saveSettings: 'Save settings',
        savingSettings: 'Saving settings',
        testExpiresAfter: 'Test expires after',
        showResultsToSubject: 'Show results to subject',
        showCalibrationAlert: 'Show calibration alerts',
        notifyMonitorsWhen: 'Notify monitors when…',
        notifySubjectsUsing: 'Notify subjects using…',
        gpsRequired: 'GPS location is required',
        deleteTestDataAfterDays: 'Delete test data after (days)',
        deleteTestDataAfterDays_doNotDelete: 'Never'
      },

      scheduleDetails: {
        weekdays: 'Weekdays',
        randomTests: 'Random tests',
        perDay: 'Per day',
        betweenTimes: 'Between times',
        fixedTests: 'Fixed tests',
      },

      scheduleEditor: {
        whichDaysHeading: 'Which days to test on',
        randomTestHeading: 'Random test',
        randomTestsWillOccurBetweenTheseTimes: 'Random tests will occur between',
        scheduledTestHeading: 'Scheduled test',
        moodQuestionHeading: 'Mood Questions',
        addMoodQuestionButton: 'Add Mood Question',
        addAnotherMoodQuestionButton: 'Add Another Question',
        howManyTestsADayAndWhichTimes: 'How many tests a day and which times?',
        removeTimeButton: 'Remove',
        addTimeButton: 'Add time',
        cancelButton: 'Cancel',
        saveButton: 'Save schedule',
        savingButton: 'Saving schedule…',
        labels: {
          name: 'Name',
          template: 'Save template copy',
          templateDescription: 'Templates can be reused with other subjects.',
          maxRandomTestsPerDay: 'Max random tests per day',
          zeroTestDescription: '0 = no random test required',
          minSecBetweenRandomTests: 'Minimum time between random tests',
          earliest: 'Earliest',
          latest: 'Latest',
          repeatCycle: 'Repeat every',
          repeatWeek: 'Week',
          repeatWeeks: 'Weeks'
        },
      },

      schedulePeriodDetails: {
        schedule: 'Schedule',
        activePeriod: 'Active period',
        period: '{{startDate | date:"shortDate"}} - {{endDate | date:"shortDate"}}',
      },

      schedulePeriodEditor: {
        cancelButton: 'Cancel',
        saveButton: 'Save schedule',
        savingButton: 'Saving schedule…',
        labels: {
          startDate: 'Start date',
          endDate: 'End date',
        },
        question: {
          deleteSchedule: 'Do you really want to remove this schedule from the subject?',
          recreateTests: 'Do you want also to re-create today\'s tests planned by this schedule?',
          deleteTests: 'Do you want also to delete today\'s planned tests created by this schedule?'
        }
      },

      externalMonitorDetails: {
        labels: {
          name: 'Name',
          phone: 'Phone number',
          email: 'Email address',
          fillAtleastOne: 'Fill at least one field'
        }
      },

      externalMonitorEditor: {
        phone: 'Phone number (including country code)',
        cancelButton: 'Cancel',
        saveButton: 'Save external monitor'
      },

      searchForm: {
        submitButton: 'Search',
        labels: {
          query: 'Search in iBac',
        },
      },

      subGroupEditor: {
        labels: {
          name: 'Name',
        },
      },

      subGroupOverview: {
        noSubjectsInSubGroup: 'There are no subjects in {{name}}.',
      },

      subjectDetails: {
        id: 'ID',
        group: 'Group',
        subGroupInMainGroup: ' in ',
        fullAddress: 'Address',
        fullAddressValue: '{{address}}, {{postalCode}}, {{city}}',
        phone: 'Phone',
        email: 'Email',
        timeZone: 'Time zone',
        highlighted: 'Highlighted',
        hasInsurance: 'Has insurance',
        ssn: 'Social security number',
        status: 'Status',
        photo: 'Subject photo',
        createdDate: 'Onboarding date',
      },

      insuranceDataDetails: {
        saveButton: 'Save insurance data',
        cancelButton: 'Cancel',
        labels: {
          provider: {
            providerUsername: 'Provider Username',
            providerLastName: 'Provider Last Name',
            providerFirstName: 'Provider First Name',
            providerMiddleName: 'Provider Middle Name',
            npi: 'NPI',
            encounterId: 'Encounter ID',
          },
          subscriber: {
            relationship: 'Subscriber relationship to Subject',
            policyNumber: 'Policy/Member Number',
            groupNumber: 'Group Number',
            insuranceRenderingProvider: 'Rendering Provider ID',
            insuranceReferringProvider: 'Referring Provider ID',
            insuranceSubscriber: 'Insurance Subscriber',
            insuranceCompany: 'Insurance Company',
            insuranceProvider: 'Provider'
          }
        }
      },

      subjectEditor: {
        groupHeading: 'Group',
        mainGroupHeading: 'Main group',
        subGroupHeading: 'Sub group',
        chooseMainGroupBeforeSubGroup: 'Choose a main group first.',
        systemLanguageHeading: 'System language',
        ruleSetHeading: 'iBac settings',
        editRuleSetButton: 'Edit',
        removeRuleSetButton: 'Remove',
        cancelRuleSetButton: 'Cancel',
        useRuleSetButton: 'Use settings',
        subjectDoesntHaveAnyRuleSets: 'The subject doesn\'t have any iBac settings.',
        addNewRuleSetButton: 'Add new settings',
        addRuleSetFromTemplateButton: 'Add settings from template',
        addNewRuleSetHeading: 'Add new iBac settings for the subject',
        addRuleSetFromTemplateHeading: 'Add iBac settings for the subject from a template',
        editTheCurrentRuleSetHeading: 'Edit the current iBac settings',
        schedulesHeading: 'Schedules',
        editScheduleButton: 'Edit',
        removeScheduleButton: 'Remove',
        subjectDoesntHaveAnySchedules: 'This subject doesn\'t have any schedules.',
        addNewScheduleButton: 'Add a new schedule',
        addScheduleFromTemplateButton: 'Add a schedule from template',
        addNewScheduleHeading: 'Add a new schedule for the subject',
        addScheduleFromTemplateHeading: 'Add a schedule for the subject from a templates',
        editingSchedule: 'Editing schedule {{name}}',
        saveSubjectButton: 'Save subject',
        savingSubjectButton: 'Saving subject…',
        crisisAgentHeading: 'Crisis agent',
        externalMonitorsHeading: 'External monitors',
        addNewExternalMonitorButton: 'Add a new external monitor',
        editExternalMonitor: 'Edit an existing external monitor',
        deleteExtMonitorQuestion: 'Do you really want to remove this external monitor from the subject?',
        subjectNoExternalMonitors: '{{firstName}} doesn\'t have any external monitors.',
        alertSelectOnlyFiveImages: 'You can select only 5 images',
        onlyFiveImagesAllowed: 'Max 5 images allowed',
        labels: {
          firstName: 'First name',
          lastName: 'Last name',
          ssn: 'Social security number',
          address: 'Street address and number',
          address1: 'Street address 1',
          address2: 'Street address 2',
          postalCode: 'Postal code',
          city: 'City',
          phone: 'Phone number (including country code)',
          cellularPhone: 'Cellular number (including country code)',
          email: 'Email address',
          timeZone: 'Time zone',
          highlighted: 'Highlighted',
          pauseScheduledTests: 'Pause scheduled tests',
          showInactiveOrganization: 'Show inactive organizations',
          secondaryPhone: 'Secondary Phone',
          gender: 'Gender',
          dateOfBirth: 'Date of birth',
          employer: 'Employer name',
          occupation: 'Occupation',
          state: 'State',
        },
        assignedIbac: 'Assigned iBac',
        addInsuranceData: 'Add insurance',
        insuranceDataHeading: 'Insurance data',
        insuranceProviderHeading: 'Provider',
        selectInsuranceProvider: 'Select Provider',
        insuranceCompanyHeading: 'Insurance Company',
        selectInsuranceCompany: 'Select Company',
        insuranceSubscriberHeading: 'Insurance Subscriber',
        selectInsuranceSubscriber: 'Select Subscriber',
        editTheCurrentInsuranceHeading: 'Edit the insurance',
        subjectAsSubscriber: "Subject is Subscriber"
      },

      subjectOverview: {
        highlighted: 'Highlighted',
        scheduledTestsArePaused: 'Scheduled tests are paused',
        sendMessageButton: 'Message',
        showProfileButton: 'Show profile',
      },

      testDetails: {
        testPassed: 'Test passed',
        testHasNotStartedYet: 'Test has not started yet',
        startsOn: 'Starts on',
        expiresOn: 'Expires on',
        allowedAlcoholValue: 'Allowed alcohol value',
        submittedAlcoholValue: 'Submitted alcohol value',
        testOpen: 'Test open',
        waitingForSampleToBeHandedIn: 'waiting for a sample to be handed in',
        testFailed: 'Test failed',
        noSampleWasHandedIn: 'no sample was handed in',
        theSampleExceededTheAllowedAlcoholLimit: 'the sample exceeded the allowed alcohol limit',
        sampleTakenOn: 'Sample was taken on',
        sampleReceivedAt: 'Server received sample at',
        deviceColor: 'Device color',
        showLocationOnMap: 'Show location on map',
        hideLocationOnMap: 'Hide location on map',
        showProfileButton: 'Show profile',
        locationNotAvailable: 'Location not available',
        feeling: 'Feeling',
        faceRecognition: {
          title: 'Face recognition',
          result: 'Result',
          createdBy: 'Created by',
          failReasonTitle: 'Fail reason',
          left: 'Left',
          right: 'Right',
          profile: 'Profile',
          failReson: '{{side}} photo - {{error}}'
        },
        faceRecognitionCheckResult: 'Face recognition result',
        faceRecognitionCheckCreatedBy: 'Face recognition created by',
        question: 'Mood Question',
        answer: 'Answer',
        RED: "red",
        YELLOW: "yellow",
        BLUE: "blue",
        PINK: "pink",
        GREEN: "green",
        RÖD: "red",
        BLÅ: "blue",
        GRÖN: "pink",
        ROSA: "green",
        GUL: "gul",
        // optionalTest: 'This sample was taken without a scheduled or random test.',
        // theSampleWasHandedInOutsideOfTheAllowedLocation: 'the sample was handed in outside of the allowed location',
      },

      testOverview: {
        opensOnDate: 'Test is scheduled to start on {{opensOnDate | date:"short"}}',
        passedOnDate: 'Passed on {{dateCreated | date:"short"}}',
        failedOnDate: 'Failed on {{dateCreated | date:"short"}}',
        expiresOnDate: 'Expired on {{expiresOnDate | date:"short"}}',
        pendingNoSampleHasBeenHandedInYet: 'Pending, no sample has been handed in yet',
        failedNoSampleWasHandedIn: 'Failed, no sample was handed in',
      },

      whenLoaded: {
        loading: 'Loading…',
      },

      activation: {
        activateButton: 'ACTIVATE',
        deactivateButton: 'DEACTIVATE',
      },
      imageMultiSelect: {
        notFound: 'Not found',
        selectAll: 'Select all',
        unselectAll: 'Unselect',
      },
      boostImageEditor: {
        header: 'Boost images'
      },
      moodQuestionComponent: {
        addMoodQuestionButton: 'Add Mood Question',
        saveQuestion: 'Save',
        question1: 'How are you feeling today?',
        question2: 'Did you get proper sleep?',
        question3: 'Do you feel anxious? Describe your feeling.',
        question4: 'Describe something good today, anything.',
        custom: "Custom:"
      },
      inactiveDays: {
        heading: 'Inactive Days',
        addInactiveDays: 'Add inactive days',
        setInactiveRange: 'Set inactive range',
        dateRangeFrom: 'Date range from',
        dateRangeTo: 'Date range to',
        selectedDate: 'Selected Date',
        saveInactiveDays: 'Save inactive days',
        confirmSetDateActive: 'Do you want to set Date as active?',
        confirmSetDateInactive: 'Do you want to set Date as InActive?'
      }
    },

    EXCEPTIONS: {
      MULTIPLE_OPEN_TESTS: '{{firstName}} already has an open test.'
    },

    "Internal Server Error":"There was a problem. Please retry and contact support if the problem still occur",
    formErrors: {
      invalidNPI: "NPI must have at least 3 digits.",
      invalidFields: "Some information is either wrong or missing. Check your input.",
      required: 'Required',
      minlength: 'Must be at least {{minLength}} characters',
      maxLength: 'Must be at most {{maxLength}} characters',
      invalidEmailAddress: 'Invalid email address',
      invalidPhoneNumber: 'The phone number may only contain numbers and spaces and must begin with a country code. Example: +46 123 456 789',
      invalidPhoneNumberInsuranceCompany: 'The phone number may only contain 10-11 numbers and spaces and must NOT contain the \+ sign in front of the country code. Example: 1123456789, 46123456789',
      invalidPassword: 'The password must be at least 8 characters long and may only contain letters from A to Z and numbers from 0 to 9.',
      invalidDateOfBirth: 'The date of birth must be in the format YYYY-MM-DD.',
      invalidMacAddress: 'Invalid MAC address format',
      invalidSSN: 'The social security number may only contain numbers. Example: 1234567890',
      outsideInterval: 'Minimal value is 5 minutes and maximum value is 720 minutes.',
      invalidPhoto: 'Unsupported image file format.',
      hasToBeNumber: 'Alcohol limit value has to be number',
      minBacLimitValue: 'Please enter value above or equal {{minBacLimitValue}}.',
      maxBacLimitValue: 'Please enter value under or equal {{maxBacLimitValue}}.',
      earliestAfterLatest: 'Earliest time cannot be after latest',
      numberRequired: 'Please enter 6-digits number',
      unauthorized: 'Unauthorized',
      unknownError: 'Unknown error',
      subjectLoginError: 'Subject accounts are not permitted to use Web UI',
    },

    formSuccess: {
      savedUser: 'Saved {{name}}. Activation email was sent to {{email}}.',
    },

    licenseTypes: {
      PRO: 'Pro',
      'PRO GROUP': 'Pro group'
    },

    locales: {
      'en': 'English',
      'sv': 'Swedish',
      'ko': 'Korean'
    },

    months: {
      'JAN': 'January',
      'JAN.short': 'Jan',
      'FEB': 'February',
      'FEB.short': 'Feb',
      'MAR': 'March',
      'MAR.short': 'Mar',
      'APR': 'April',
      'APR.short': 'Apr',
      'MAY': 'May',
      'MAY.short': 'May',
      'JUN': 'June',
      'JUN.short': 'Jun',
      'JUL': 'July',
      'JUL.short': 'Jul',
      'AUG': 'August',
      'AUG.short': 'Aug',
      'SEP': 'September',
      'SEP.short': 'Sep',
      'OCT': 'October',
      'OCT.short': 'Oct',
      'NOV': 'November',
      'NOV.short': 'Nov',
      'DEC': 'December',
      'DEC.short': 'Dec'
    },

    notificationEvents: {
      testPassed: 'Test passed',
      testFailed: 'Test failed',
      optionalTestPassed: 'Optional test passed',
      optionalTestFailed: 'Optional test failed',
      testExpired: 'Test expired',
      frs: 'Has face recognition result'
    },

    notificationMethods: {
      sms: 'SMS',
      email: 'Email',
      push: 'Push message',
    },

    units: {
      minute: {
        short: 'min',
        long: 'minute',
      },
    },

    roles: {
      ROLE_SUPER_ADMIN: 'Super admin',
      ROLE_ADMIN: 'Admin',
      ROLE_GROUP_ADMIN: 'Group admin',
      ROLE_SUBJECT: 'Subject',
    },

    views: {
      404: {
        heading: 'Error 404, page not found',
        homeLink: 'Go to startpage',
      },

      addAgent: {
        heading: 'Add agent',
        save: 'Save settings',
        saving: 'Saving settings…',
        addedHeading: 'Added agents',
        nothingAdded: 'You haven\'t added any new agents.',
      },

      addGroup: {
        mainGroupHeading: 'Add main group',
        saveMainGroup: 'Save main group',
        savingMainGroup: 'Saving main group…',
        addedMainGroupsHeading: 'Added main groups',
        noMainGroupsAdded: 'You haven\'t added any main groups.',
        subGroupHeading: 'Add sub group',
        chooseMainGroupToAddSubGroups: 'Choose the main group that you want to add sub groups to.',
        saveSubGroup: 'Save sub group',
        savingSubGroup: 'Saving sub group…',
        addedSubGroupsInMainGroupHeading: 'Added sub groups in {{name}}',
        noSubGroupsAdded: 'You haven\'t added any sub groups.',
      },

      addIbac: {
        heading: 'Add iBac',
        save: 'Save iBac',
        saving: 'Saving iBac…',
        addedHeading: 'Added iBac units',
        nothingAdded: 'You haven\'t added any new iBac units.',
      },

      addOrganization: {
        heading: 'Add organization',
        save: 'Save organization',
        saving: 'Saving organization…',
        addedHeading: 'Added organizations',
        nothingAdded: 'You haven\'t added any new organizations.',
      },

      addRuleSet: {
        heading: 'Add settings template',
        addedHeading: 'Added settings templates',
        nothingAdded: 'You haven\'t added any new settings templates.',
      },

      addSchedule: {
        heading: 'Add schedule template',
        addedHeading: 'Added schedule templates',
        nothingAdded: 'You haven\'t added any new schedule templates.',
      },

      addSubject: {
        heading: 'Add subject',
        addedHeading: 'Added subjects',
        nothingAdded: 'You haven\'t added any new subjects.',
      },

      addInsuranceProvider: {
        heading: 'Add provider',
        addedHeading: 'Added providers',
        nothingAdded: 'You haven\'t added any new providers.',
      },

      addInsuranceSubscriber: {
        heading: 'Add insurance subscriber',
        addedHeading: 'Added insurance subscribers',
        nothingAdded: 'You haven\'t added any new insurance subscribers.',
      },

      addInsuranceCompany: {
        heading: 'Add insurance company',
        addedHeading: 'Added insurance companies',
        nothingAdded: 'You haven\'t added any new insurance companies.',
      },

      add: {
        peopleOrGroupsHeading: 'Add new people or groups',
        planTemplatesHeading: 'Add new plan templates',
        organizationsHeading: 'Add new organizations and iBac units',
        agent: 'Agent',
        subject: 'Subject',
        insuranceProvider: 'Provider',
        insuranceSubscriber: 'Insurance Subscriber',
        insuranceCompany: 'Insurance Company',
        group: 'Group',
        schedule: 'Schedule template',
        settings: 'Settings template',
        organization: 'Organization',
        ibac: 'iBac'
      },

      upload: {
        subjects: 'Upload CSV with subjects',
        subjectsHeading: 'Upload CSV with subjects'
      },

      alerts: {
        noAlerts: 'There are no {{filterToPrint}}'
      },

      editAgent: {
        heading: 'Edit profile for {{fullName}}',
        save: 'Save settings',
        saving: 'Saving settings…',
      },

      editMainGroup: {
        heading: 'Editing {{name}}',
        save: 'Save main group',
        saving: 'Saving main group…',
      },

      editOrganization: {
        heading: 'Editing {{name}}',
        save: 'Save organization',
        saving: 'Saving organization…',
      },

      editRuleSet: {
        heading: 'Editing {{name}}',
      },

      editSchedulePeriod: {
        heading: 'Editing {{schedulePeriod}} for {{subject}}',
      },

      editSchedule: {
        heading: 'Editing {{name}}',
      },

      editSubGroup: {
        heading: 'Editing {{name}}',
        save: 'Save sub group',
        saving: 'Saving sub group…',
      },

      editSubject: {
        heading: 'Editing {{fullName}}',
      },

      editIbac: {
        heading: 'Editing {{macAddress}}',
        cancel: 'Cancel',
        saveEvent: 'Save event',
        addNewEvent: 'Add new event',
        editEvent: 'Edit event',
        removeEvent: 'Remove event',
        activate: 'Activate',
        deactivate: 'Deactivate',
        activateAt: 'Activate at',
        deactivateAt: 'Deactivate at',
        setEventAndType: 'Set event type and time',
        noEvents: 'No planned events',
        deleteEventQuestion: 'Do you really want to remove this event?',
        eventsOfIbac: 'iBac events',
        eventType: 'Event type',
        eventTime: 'Event time',
        required: 'required',
      },

      forgotPassword: {
        heading: 'Forgot password',
        resetEmailSentTitle: 'Request received',
        resetEmailSentDescription: 'An email with a link to reset the password has been sent to {{email}}.',
        labels: {
          email: 'Email',
        },
        submitButton: 'Request new password',
        backToLogin: 'Back to login',
      },

      home: {
        filtersHeading: 'Which groups would you like to see?',
        allGroupsFilter: 'All groups',
        highlightedSubjectsFilter: 'Highlighted subjects',
        noHighlightedSubjects: 'There are no highlighted subjects in the groups that you\'re a monitor of.',
        inactiveSubjectsFilter: 'Inactive subjects',
        noInactiveSubjects: 'There are no inactive subjects in the groups that you\'re a monitor of.'
      },

      listAgents: {
        heading: 'Agents',
      },

      listOrganizations: {
        heading: 'Organizations',
        noActiveOrganizations: 'No active organizations.',
        noInactiveOrganizations: 'No inactive organizations.',
        sortByName: 'Sort organizations by name'
      },

      listRuleSets: {
        heading: 'Settings templates',
        noRuleSets: 'No settings templates'
      },

      listSchedules: {
        heading: 'Schedule templates',
        noSchedules: 'No schedule templates'
      },

      listSubjects: {
        heading: 'Subjects',
      },

      listIbacs: {
        heading: 'iBac devices',
        noIbacs: 'No iBac units.',
        noActiveIbacs: 'No active iBac units.',
        noInactiveIbacs: 'No inactive iBac units.',
        noTamperedIbacs: 'No tampered iBac units.',
      },

      listAlerts: {
        heading: 'Alerts overview',
        dateHeading: 'Date',
        startDate: 'Start date',
        endDate: 'End date',
        eventTypeHeading: 'Event type',
        subjectNameHeading: 'Name of the subject',
        groupHeading: 'Group',
        ibacHeading: 'iBac device',
        noAll: 'alerts or violations'
      },

      login: {
        heading: 'Welcome',
        labels: {
          email: 'Email',
          password: 'Password',
        },
        submitButton: 'Login',
        forgotPassword: 'Forgot password',
        rememberMe: 'Remember me'
      },

      reports: {
        download: 'Download',
        processing: 'Processing...',
        groups:{
          subject:'Subject',
          ibac:'iBac'
        }
      },

      search: {
        heading: 'Search',
        domains: {
          everything: 'Everything',
          subjects: 'Subjects',
          agents: 'Agents',
          mainGroups: 'Main groups',
          subGroups: 'Sub groups',
          organizations: 'Organizations',
          ibacs: 'iBacs'
        },
        subjectsHeading: 'Subjects',
        noSubjectsFound: 'No subjects found.',
        agentsHeading: 'Agents',
        noAgentsFound: 'No agents found.',
        mainGroupsHeading: 'Main groups',
        noMainGroupsFound: 'No main groups found.',
        subGroupsHeading: 'Sub groups',
        noSubGroupsFound: 'No sub groups found.',
        organizationsHeading: 'Organizations',
        noOrganizationsFound: 'No organizations found.',
        ibacsHeading: 'iBacs',
        noIbacsFound: 'No iBacs found.'
      },

      setPassword: {
        invalidTokenHeading: 'Invalid password token.',
        goToLogin: 'Go to login',
        heading: 'Choose password',
        labels: {
          password: 'Password',
          confirmPassword: 'Confirm password'
        },
        passwordsDontMatch: 'The passwords do not match.',
        submitButton: 'Save',
        passwordSavedHeading: 'Password saved.',
        continueButton: 'Continue',
        subjectCanNowUseTheMobileApp: 'You can now use the mobile app.',
      },

      singleAgent: {
        editAgent: 'Edit agent',
        editYourself: 'Edit profile',
      },

      singleMainGroup: {
        addSubGroups: 'Add sub groups',
        editMainGroup: 'Edit main group',
        mainGroupDoesntHaveAnySubGroups: 'This main group doesn\'t have any sub groups.',
        subjectsCount: '{{length}} subjects',
        agentsCount: '{{length}} agents',
        seeWholeGroup: 'See whole group',
        deleteMainGroup: 'DELETE',
      },

      singleOrganization: {
        editOrganization: 'Edit organization',
        downloadReportsHeading: 'Download reports',
        startDate: 'Start date',
        endDate: 'End date',
        ibacsHeading: 'iBac units connected to this organization',
        noIbacsInOrganization: 'No iBac units are connected to this organization.',
        noActiveIbacsInOrganization: 'No active iBac units are connected to this organization.',
        noInactiveIbacsInOrganization: 'No inactive iBac units are connected to this organization.',
        ibacUsageReport: 'iBac usage',
        subjectUsageReport: 'Subjects usage',
        includeOptionalSample: "Include optional samples",
        activeOffenders: 'Active offenders',
        activeDays: 'Active days',
        fieldUnitsStatusReport: 'Field units status report',
        endOfProgramReport: "End of program report",
        activatedIBacUnits: 'Activated iBac units report',
        scheduleChangesReport: "Schedule changes",
        ibacAssignmentHistory: 'iBac assignment history',
        startOfProgramSubjects: 'Start of program report',
        currentIbacStatus: 'Current iBac status',
        subjectStatusReport: 'Subject status',
        subjectDeviceAssignmentHistory: 'Subject device assignment history'
      },

      singleRuleSet: {
        editRuleSet: 'Edit settings template',
      },

      singleSchedule: {
        editSchedule: 'Edit schedule template',
      },

      singleSubGroup: {
        subGroupInMainGroupHeading: '{{name}} in',
        editSubGroup: 'Edit sub group',
        agentsHeading: '{{length}} agents',
        showProfile: 'Show profile',
        subjectsHeading: '{{length}} subjects',
      },

      singleSubject: {
        subjectFirstNameHasNeverUsedTheMobileApp: '{{firstName}} has never used the mobile app.',
        firstLoginNotice: 'No scheduled tests will be created till the first login to the app.',
        instantNewTest: 'Instant new test',
        editSubject: 'Edit subject',
        immediateTestSuccess: 'A new test was created and a notification has been sent to {{firstName}}.',
        scheduledTestsHeading: 'Scheduled tests',
        scheduledTestsArePaused: 'Scheduled tests are paused',
        editTheSubjectToResumeTheScheduledTests: 'Edit the subject to resume the scheduled tests.',
        subjectFirstNameDoesntHaveAnyScheduledTestsYet: '{{firstName}} has not had any scheduled tests yet.',
        optionalAlcoholSamplesHeading: 'Optional alcohol samples',
        subjectFirstNameDoesntHaveAnyOptionalAlcoholSamplesYet: '{{firstName}} has not handed in any optional alcohol samples yet.',
        messagesHeading: 'SMS messages',
        subjectFirstNameHasNotReceivedAnyMessagesYet: '{{firstName}} has not received any SMS messages yet.',
        newSmsMessage: 'New SMS message',
        showSamplesChart: 'Show samples chart',
        notesHeading: 'Notes',
        messageAuthor: 'Author',
        noteAuthor: 'Author',
        sent: 'Sent',
        created: 'Created',
        edit: 'Edit',
        saveNote: 'Save note',
        cancel: 'Cancel',
        addNoteHeading: 'Add note',
        saveNote: 'Save note',
        savingNote: 'Saving note…',
        settingsHeading: 'iBac settings',
        scheduleHeading: 'Schedule',
        subjectFirstNameDoesntHaveAnySchedules: '{{firstName}} doesn\'t have any schedules.',
        externalMonitorsHeading: 'External monitors',
        subjectNoExternalMonitors: '{{firstName}} doesn\'t have any external monitors.',
        agents: 'Agents',
        subjectNoAgents: '{{firstName}} doesn\'t have any agents.',
        subjectUsage: "Subject usage report",
        subjectSummaryReport: "Subject summary report",
        resetPassword: 'Reset password',
        deleteSubject: 'DELETE',
      },

      templates: {
        heading: 'Templates',
        menuItems: {
          schedule: 'Schedule templates',
          settings: 'Settings templates',
        },
      },

      mfa: {
        two_factor: "Two factor authentication",
        setup_prompt: "Please set up two factor authentication for your account",
        enable_now: "Enable now",
        skip: "Skip",
        mfa_code_sent: "Authentication code was sent to your mobile phone",
        enter_mfa_code: "Enter authentication code:",
        verify: "Verify",
        failedToEnableMfa: "Failed to enable two factor authentication"
      }
    },

    weekdays: {
      'MON': 'Monday',
      'MON.short': 'Mon',
      'TUE': 'Tuesday',
      'TUE.short': 'Tue',
      'WED': 'Wednesday',
      'WED.short': 'Wed',
      'THU': 'Thursday',
      'THU.short': 'Thu',
      'FRI': 'Friday',
      'FRI.short': 'Fri',
      'SAT': 'Saturday',
      'SAT.short': 'Sat',
      'SUN': 'Sunday',
      'SUN.short': 'Sun'
    },

    states: {
      'active': 'ACTIVE',
      'inactive': 'INACTIVE',
      'tampered': 'TAMPERED'
    },

    ibacFilter: {
      'all': 'All devices',
      'active': 'Active devices',
      'inactive': 'Inactive devices',
      'tampered': 'Tampered devices'
    },

    organizationFilter: {
      'all': 'All organizations',
      'active': 'Active organizations',
      'inactive': 'Inactive organizations'
    },

    alertFilter: {
      'all': 'All',
      'alerts': 'Alerts',
      'violations': 'Violations'
    },

    violation: {
      optional_sample: "Optional sample failed",
      test_expired: "Test expired",
      test_failed: "Test failed",
      liveness_error: "Alcohol sample error - face detection error"
    },

    alert: {
      ibac_tampered: "iBac tampered",
      ibac_battery: "Low iBac battery",
      ibac_calibration: "iBac calibration needed",
      face_recognition: 'Face recognition failed'
    },

    paging: {
      per_page_amount: "Results per page",
      date_from_clean: "Clean date from",
      date_to_clean: "Clean date to"
    },

    frsFailReason: {
      WRONG_COLOR: 'Wrong iBac color detected',
      NO_FACES_TESTED_IMAGE: 'No face found on the photo',
      NO_FACES_PROFILE_PICTURE: 'No face found on the profile photo',
      ONLY_SMALL_FACES: 'Face on the photo is too small',
      SUBJECT_DETECTED_MULTIPLE_TIMES: 'Subject detected multiple times on photo',
      NO_SUBJECT_DETECTED: 'Subject not found on the photo',
      NO_IBAC_DETECTED: 'No iBac device detected on the photo',
      DEVICE_SUBJECT_NO_OVERLAP: 'iBac device is not in the subject\'s mouth',
      INVALID_IBAC_POSITION: 'iBac device in a wrong position',
      MULTIPLE_FACES_DETECTED: 'Multiple faces detected on the photo',
      UNKNOWN: 'Face recognition error',
    },

    alcosystemsFailReason: {
      FACE_SPOOFING: 'A liveness check couldn\'t be performed',
      NO_FACES: 'No face found on the photo',
      MULTIPLE_SUBJECTS: 'Multiple faces detected on the photo',
      SMALL_FACES: 'Face on the photo is too small',
      FACES_NEAR_BORDER: 'Subject\'s face is too close to the frame borders',
      FOUND_MULTIPLE_SUBJECTS: 'Multiple faces detected on the photo',
      SUBJECT_NOT_RECOGNIZED: 'Subject not found on the photo',
      MULTIPLE_IBACS: 'Multiple iBac devices detected on the photo',
      NO_IBACS: 'No iBac device detected on the photo',
      IBAC_NEAR_BORDERS: 'iBac device is too close to the image border',
      IBAC_WRONG_COLOR: 'Wrong iBac color detected',
      IBAC_CANT_CONFIRM_POSITION: 'Could not confirm that subject is blowing into the iBac',
    },

    frsResult: {
      PASSED: "PASSED",
      FAILED: "FAILED",
    },

    livenessError: {
      FACE_ANGLE_TOO_LARGE: 'Face on the picture is too large.',
      FACE_CLOSE_TO_BORDER: 'Face is too close to one or more picture borders',
      FACE_CROPPED: 'Face is cropped on the picture',
      FACE_NOT_FOUND: 'No face detected in the photo',
      FACE_TOO_CLOSE: 'Face on the picture is too close',
      FACE_TOO_SMALL: 'Face on the picture is too small',
      TOO_MANY_FACES: 'Too many face detected',
      FACE_IS_OCCLUDED: 'Face on the picture is occluded',
      UNKNOWN: 'Face detection error',
      LIVENESS_FAILED: 'No live face detected on the photo'
    }

  })
